module.exports = __webpack_public_path__ + "img/mm_b2_pic4.02c35c3b.png";